import React from 'react';
import { useTranslation } from 'react-i18next';

export const MeetingTopicTakeawaysTitle = () => {
  const { t } = useTranslation();

  return (
    <div className="infoMeetingDetails displayTable">
      <div className="topicHead displayCell" style={{ borderRight: '5px solid #ECEFF1' }}>
        <div className="firstDivtopic">
          <div className="oneononebox-inners  oneonone-meeting-table">
            <div>
              <div className="oneonone-label">{t('Topics for Discussion')}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="takeawayHead displayCell">
        <div className="firstDivTakeaways">
          <div className="oneononebox-inners  oneonone-meeting-table">
            <div>
              <div className="oneonone-label">{t('Takeaways')}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
